import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
  ElementRef,
  Renderer2,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';

import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { LastItemBgClass } from '../../shell/shell.service';
import { JotformBlock } from 'www-cms';
import { DirectusDirective } from 'directus';

@Component({
  selector: 'ss-www-jotform-block',
  standalone: true,
  imports: [DirectusDirective],
  templateUrl: './jotform-block.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JotformBlockComponent
  extends BaseBuildingBlockComponent
  implements AfterViewInit, OnDestroy
{
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  @Input({ required: true }) jotformBlockData!: JotformBlock;

  ngAfterViewInit(): void {
    const container =
      this.elementRef.nativeElement.querySelector('#jotform-container');

    this.renderer.setProperty(container, 'innerHTML', '');
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://form.jotform.com/jsform/${this.jotformBlockData.formID}`;
    script.async = true;
    this.renderer.appendChild(container, script);
  }

  ngOnDestroy(): void {
    const container =
      this.elementRef.nativeElement.querySelector('#jotform-container');
    if (container) {
      this.renderer.setProperty(container, 'innerHTML', '');
    }
  }

  override getBgClass(): LastItemBgClass {
    return 'bg-ss-www-background';
  }
}
